import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { crc32Hex } from '@/lib/crc32';
import { Tablet, tabletQrSource } from '@/lib/schema/tablet';
import { QRCodeCanvas } from 'qrcode.react';

type TabletQrDialogProps = {
  tablet: Tablet | null;
  eventKey: string;
  onOpenChange: (open: boolean) => void;
};

export function TabletQrDialog({
  tablet,
  eventKey,
  onOpenChange,
}: TabletQrDialogProps) {
  const source =
    tablet && tablet.qrEnabled ? tabletQrSource(tablet, eventKey) : null;
  const code = source ? crc32Hex(source) : null;

  return (
    <Dialog open={!!tablet} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[380px]">
        <DialogHeader>
          <DialogTitle>{tablet?.name}</DialogTitle>
          <DialogDescription>
            CRC32 of Suite ID_Single event key_Event key, in hex without leading zeros, like the tablet app.
          </DialogDescription>
        </DialogHeader>
        {tablet && code ? (
          <div className="flex flex-col items-center gap-3">
            {/* White backing so the code scans in dark mode too. */}
            <div className="rounded-md bg-white p-3">
              <QRCodeCanvas value={code} size={256} level="M" marginSize={2} />
            </div>
            <span className="font-mono text-2xl tracking-wider">{code}</span>
            <dl className="grid w-full grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
              <dt className="text-muted-foreground">Source</dt>
              <dd className="font-mono">{source}</dd>
              <dt className="text-muted-foreground">PIN</dt>
              <dd className="font-mono">{tablet.pin || '-'}</dd>
              <dt className="text-muted-foreground">Location</dt>
              <dd>{tablet.location}</dd>
            </dl>
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">
            {tablet && !tablet.qrEnabled
              ? 'QR code is disabled for this tablet. Enable it in the tablet settings to generate a code.'
              : 'This tablet has no Suite ID yet. Edit the tablet and set one to generate its QR code.'}
          </p>
        )}
      </DialogContent>
    </Dialog>
  );
}
